export const IconSamespace = (
  <svg
    width="105"
    height="24"
    viewBox="0 0 105 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8722 23.8503C16.7161 23.3891 19.0617 22.139 20.9698 20.0635C22.2824 18.6313 23.0845 17.1749 23.7165 15.0994C24.0203 14.1163 24.0446 13.8372 24.0446 12.0166C24.0568 9.80764 23.9109 9.043 23.1453 7.22244C22.3917 5.41401 20.6295 3.20505 19.1711 2.24622L18.6485 1.89424L16.5216 4.01824C15.1483 5.38973 14.3583 6.2636 14.2732 6.51848C14.018 7.29526 14.2003 7.59869 16.0476 9.4678C16.9956 10.4388 17.8463 11.3612 17.9314 11.519C18.3082 12.2593 18.2596 12.32 12.6811 17.891L7.44297 23.1099L8.25726 23.3769C10.0924 23.9959 11.9884 24.1537 13.8722 23.8503ZM9.93444 17.3084C10.0681 16.6044 9.83721 16.2524 8.14788 14.5654C7.23637 13.6672 6.40993 12.7812 6.3127 12.5992C6.09394 12.1865 6.09394 11.7253 6.3127 11.3126C6.40993 11.1306 8.7677 8.7153 11.5387 5.94804C14.3218 3.18078 16.5945 0.886862 16.5945 0.838314C16.5945 0.753354 15.5615 0.437789 14.492 0.195046C13.2645 -0.0841072 10.7244 -0.0598328 9.46045 0.243595C6.9933 0.838314 5.03659 1.94279 3.38372 3.69054C1.4027 5.77812 0.406115 7.95066 0.0658174 10.8757C-0.371708 14.6504 1.4027 18.8377 4.47753 21.3015L5.47411 22.1025L7.67389 19.8814C9.22954 18.3158 9.89797 17.5633 9.93444 17.3084Z"
      fill="white"
    />
    <path
      d="M75.3026 19.6877H73.3742V9.11232C74.417 8.57406 75.5739 8.28895 76.7496 8.28048C77.7854 8.25754 78.7948 8.60517 79.593 9.25967C80.4117 9.96548 80.8446 10.9857 80.8446 12.2102C80.8634 13.2095 80.5268 14.1834 79.8936 14.9614C79.2197 15.7525 78.2193 16.1969 77.175 16.169C76.5019 16.1354 75.8524 15.9125 75.3026 15.5263V19.6877ZM76.5508 9.87151C76.118 9.87197 75.6913 9.9725 75.3045 10.1651V13.7429C75.6507 14.2756 76.2467 14.597 76.886 14.5958C76.9338 14.5958 76.9816 14.594 77.0294 14.5904C77.5236 14.5813 77.9844 14.3416 78.2726 13.9437C78.6322 13.4423 78.8165 12.838 78.7972 12.2231C78.8208 11.6106 78.6149 11.0111 78.219 10.54C77.8048 10.0933 77.2137 9.84894 76.6018 9.87151H76.5508ZM69.4152 16.2138C68.3608 16.2109 67.3359 15.8692 66.4943 15.2398L67.2019 13.8737C67.6608 14.3169 68.5636 14.7753 69.2811 14.7753C69.5155 14.7827 69.7468 14.7208 69.9456 14.5975C70.1632 14.4448 70.2854 14.1913 70.2686 13.9276C70.2686 13.5138 69.7046 13.1853 69.0516 12.804C68.5653 12.5439 68.11 12.2304 67.6942 11.8695C67.2451 11.4431 67.0268 10.9892 67.0268 10.4797C67.027 10.1917 67.0905 9.90713 67.2128 9.64582C67.3386 9.37638 67.5184 9.13512 67.7413 8.9367C68.2708 8.48437 68.9511 8.24328 69.6499 8.26027C69.6801 8.26027 69.7105 8.25932 69.7406 8.25932C70.6424 8.26077 71.5181 8.55935 72.2299 9.10805L71.536 10.4222C71.4301 10.3047 70.7373 9.70757 69.9891 9.70757C69.7588 9.70129 69.5319 9.76309 69.3372 9.88509C69.1647 9.9933 69.0604 10.1817 69.0609 10.384C69.0609 10.8679 69.6324 11.1877 70.2941 11.5581C70.7669 11.7979 71.2076 12.0954 71.6059 12.4435C72.0126 12.8042 72.2452 13.3193 72.2458 13.8601C72.268 14.5195 71.9851 15.1528 71.4775 15.5797C70.9759 15.9946 70.263 16.2138 69.4152 16.2138ZM34.4789 16.2046C33.426 16.2047 32.4015 15.8661 31.5594 15.2398L32.2671 13.8737C32.7259 14.3169 33.6288 14.7753 34.3463 14.7753C34.5806 14.7827 34.8118 14.7208 35.0105 14.5975C35.2282 14.4448 35.3504 14.1913 35.3336 13.9276C35.3336 13.5138 34.7692 13.1853 34.1158 12.804C33.6292 12.544 33.1735 12.2306 32.7575 11.8698C32.308 11.4434 32.0895 10.9895 32.0895 10.48C32.0897 10.1905 32.1532 9.90444 32.2757 9.64155C32.4014 9.37096 32.5813 9.12855 32.8046 8.92911C33.3335 8.47599 34.0136 8.23428 34.7125 8.25111C34.7444 8.25111 34.7753 8.25 34.8064 8.25C35.7073 8.25139 36.582 8.55001 37.2926 9.09874L36.61 10.4137C36.4447 10.2526 36.2584 10.114 36.0562 10.0015C35.7556 9.81866 35.413 9.71459 35.0606 9.69904C34.8304 9.69285 34.6035 9.75471 34.4089 9.87672C34.2364 9.98488 34.1321 10.1732 34.1325 10.3755C34.1325 10.8594 34.7041 11.1794 35.3658 11.5497C35.8385 11.7896 36.2791 12.087 36.6774 12.4351C37.0841 12.7958 37.3167 13.3109 37.3173 13.8517C37.3395 14.5111 37.0566 15.1444 36.549 15.5713C36.0482 15.9861 35.3353 16.2053 34.4873 16.2053L34.4789 16.2046ZM93.1008 16.1822C92.0537 16.1821 91.0509 15.7637 90.3191 15.0217C89.5872 14.2796 89.1881 13.2766 89.212 12.2392C89.212 9.98237 90.9793 8.28048 93.3229 8.28048C94.2381 8.28703 95.1271 8.58411 95.8594 9.12811L95.1951 10.5056C94.6933 10.0918 94.0643 9.85963 93.4115 9.84718C92.8291 9.84405 92.2702 10.0747 91.8623 10.4867C91.4077 10.9639 91.1645 11.6014 91.1865 12.2573C91.1754 12.8866 91.4067 13.4966 91.8333 13.9629C92.2365 14.3951 92.8039 14.6401 93.3978 14.6384C94.1709 14.6238 94.9151 14.3448 95.5044 13.8487L96.1101 15.1609C95.8275 15.4223 95.5004 15.632 95.1439 15.7804C94.5047 16.0538 93.8146 16.1906 93.1185 16.1821L93.1008 16.1822ZM100.571 16.1822C99.3382 16.1822 98.2921 15.8136 97.5465 15.1162C96.7957 14.4142 96.399 13.4241 96.399 12.2528C96.3792 11.1943 96.7869 10.1718 97.5317 9.41271C97.895 9.05296 98.3284 8.77021 98.8054 8.58166C99.3202 8.37956 99.8694 8.27768 100.423 8.28159C101.568 8.28159 102.517 8.69063 103.168 9.46435C103.756 10.1623 104.079 11.1426 104.079 12.2246V12.955H98.3437C98.4091 13.5452 98.7712 14.0626 99.306 14.3303C99.8358 14.5723 100.416 14.6861 100.999 14.6621C101.035 14.6632 101.071 14.6638 101.107 14.6638C101.88 14.6628 102.63 14.405 103.238 13.9317L103.799 15.2623C103.458 15.5201 103.074 15.7182 102.665 15.8482C101.991 16.0728 101.283 16.1858 100.571 16.1822ZM100.437 9.77011C99.9362 9.75653 99.4473 9.92159 99.0593 10.2352C98.6813 10.572 98.4292 11.0255 98.3439 11.5221H102.148C102.149 11.0685 101.982 10.6301 101.679 10.2902C101.36 9.94795 100.907 9.75816 100.437 9.77011ZM84.794 16.1822C83.7171 16.1822 82.8337 15.9005 82.2383 15.3673C81.9704 15.1286 81.7592 14.834 81.6201 14.5046C81.4842 14.1789 81.4155 13.8295 81.418 13.477C81.4114 13.0956 81.5083 12.7194 81.6986 12.3879C81.8774 12.0915 82.1252 11.8418 82.4212 11.6596C83.0451 11.2934 83.7602 11.108 84.4851 11.1247C84.998 11.1247 85.9386 11.2972 86.371 11.6208V10.8505C86.371 10.1817 85.8425 9.81339 84.8831 9.81339C84.1619 9.82237 83.45 9.9758 82.7902 10.2644L82.23 8.91174C83.0969 8.49735 84.0467 8.28145 85.0092 8.28001H85.0213C86.2166 8.28001 87.0439 8.54849 87.5523 9.10126C87.9986 9.58659 88.2057 10.2858 88.2057 11.3027V15.2623C87.8239 15.5473 87.3924 15.7605 86.9328 15.8911C86.2385 16.0934 85.5177 16.1916 84.794 16.1822ZM84.8007 12.467C84.4562 12.4582 84.1167 12.5503 83.8249 12.7318C83.5611 12.8951 83.4011 13.1817 83.4017 13.4899C83.3901 13.8446 83.5419 14.1852 83.8143 14.4156C84.1353 14.6578 84.5321 14.7802 84.9351 14.7613C84.9688 14.7624 85.0033 14.763 85.0374 14.763C85.4975 14.7624 85.9514 14.6569 86.3638 14.4547V13.0081C85.9152 12.6655 85.367 12.4758 84.8007 12.467ZM62.6037 16.1821C61.3709 16.1821 60.3246 15.8134 59.5791 15.116C58.8282 14.414 58.4316 13.4239 58.4316 12.2527C58.4127 11.1941 58.8207 10.1719 59.5652 9.41255C59.9284 9.05286 60.3617 8.77016 60.8386 8.58166C61.3532 8.37955 61.9024 8.27767 62.4559 8.28159C63.6006 8.28159 64.5498 8.69063 65.201 9.46435C65.7885 10.1623 66.112 11.1426 66.112 12.2246V12.955H60.3764C60.442 13.5452 60.8041 14.0626 61.3389 14.3303C61.8684 14.5729 62.4485 14.6872 63.0314 14.6638C63.0671 14.665 63.1035 14.6656 63.1395 14.6656C63.9123 14.6645 64.6625 14.4067 65.27 13.9334L65.832 15.2637C65.4904 15.5215 65.107 15.7196 64.6982 15.8496C64.0232 16.0738 63.3155 16.1861 62.6037 16.1821ZM62.4695 9.76995C61.9689 9.75636 61.48 9.92142 61.0918 10.2351C60.7138 10.5718 60.4616 11.0253 60.3763 11.5219H64.18C64.1806 11.0684 64.0138 10.6303 63.7112 10.29C63.392 9.94794 62.9396 9.75867 62.4696 9.77059L62.4695 9.76995ZM41.2827 16.1821C40.2058 16.1821 39.3224 15.9003 38.727 15.3671C38.459 15.1283 38.2479 14.8336 38.1088 14.5042C37.9731 14.1787 37.9044 13.8297 37.9067 13.4776C37.8998 13.096 37.9966 12.7197 38.1869 12.3879C38.3656 12.0915 38.6134 11.8418 38.9095 11.6596C39.5333 11.2934 40.2484 11.108 40.9734 11.1247C41.4862 11.1247 42.4269 11.2972 42.8593 11.6208V10.8505C42.8593 10.1817 42.3308 9.81339 41.3713 9.81339C40.6501 9.82237 39.9382 9.9758 39.2784 10.2644L38.7166 8.91174C39.5852 8.4973 40.5366 8.28141 41.5006 8.28001H41.5262C42.7198 8.28001 43.545 8.54849 44.0491 9.10126C44.49 9.5847 44.6952 10.2842 44.6952 11.3027V15.2623C44.3133 15.5473 43.8819 15.7605 43.4223 15.8911C42.7278 16.0935 42.0066 16.1915 41.2827 16.1821ZM41.2894 12.4668C40.9449 12.458 40.6054 12.5501 40.3134 12.7317C40.0496 12.8949 39.8896 13.1816 39.8903 13.4898C39.8786 13.8444 40.0304 14.185 40.3026 14.4154C40.6228 14.6575 41.019 14.78 41.4214 14.7611C41.4558 14.7622 41.4907 14.7629 41.5251 14.7629C41.9856 14.7623 42.4397 14.6567 42.8524 14.4544V13.0081C42.4026 12.6678 41.8552 12.4782 41.2894 12.4668ZM52.703 15.9638H50.7714V11.1819C50.7714 10.368 50.3889 9.95537 49.6341 9.95537C49.3056 9.97174 48.9871 10.0725 48.7097 10.2477C48.4747 10.3822 48.264 10.5547 48.0863 10.758V15.9635H46.1443V8.49922H48.0759V9.27467C48.7047 8.66563 49.54 8.31086 50.4187 8.27969C50.8861 8.2605 51.3451 8.4076 51.7127 8.69443C51.9398 8.88959 52.1196 9.13307 52.2386 9.40671V9.40576C52.7685 9.01314 53.753 8.28048 54.9237 8.28048C55.7067 8.28048 56.306 8.49717 56.7051 8.92469C57.117 9.36691 57.3266 10.0437 57.3266 10.9385V15.9633H55.4019V11.2608C55.4019 10.8291 55.3152 10.5013 55.144 10.2866C54.9484 10.0597 54.6557 9.93847 54.3554 9.95995C53.7216 9.99787 53.1283 10.2816 52.704 10.7496V15.9636L52.703 15.9638Z"
      fill="white"
    />
  </svg>
);

export const IconStories = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0972 7.36098C12.0972 7.66271 11.8526 7.90731 11.5509 7.90731H0.546335C0.244602 7.90731 0 7.66271 0 7.36098V1.42915C0 1.12741 0.244602 0.882812 0.546334 0.882812H11.5509C11.8526 0.882812 12.0972 1.12741 12.0972 1.42915V7.36098ZM6.4389 2.83425H1.9511C1.62804 2.83425 1.36582 3.09648 1.36582 3.41953C1.36582 3.74286 1.62804 4.00508 1.9511 4.00508H6.4389C6.76222 4.00508 7.02445 3.74286 7.02445 3.41953C7.02445 3.09648 6.76222 2.83425 6.4389 2.83425ZM10.3414 5.17564H1.9511C1.62804 5.17564 1.36582 5.43787 1.36582 5.76119C1.36582 6.08424 1.62804 6.34647 1.9511 6.34647H10.3414C10.6648 6.34647 10.9267 6.08424 10.9267 5.76119C10.9267 5.43787 10.6648 5.17564 10.3414 5.17564ZM0.546335 17.1171C0.244602 17.1171 0 16.8725 0 16.5708V10.639C0 10.3372 0.244602 10.0926 0.546335 10.0926H15.4538C15.7555 10.0926 16.0001 10.3372 16.0001 10.639V16.5708C16.0001 16.8725 15.7555 17.1171 15.4538 17.1171H0.546335ZM6.4389 12.0441H1.9511C1.62804 12.0441 1.36582 12.306 1.36582 12.6294C1.36582 12.9527 1.62804 13.2146 1.9511 13.2146H6.4389C6.76222 13.2146 7.02445 12.9527 7.02445 12.6294C7.02445 12.306 6.76222 12.0441 6.4389 12.0441ZM10.3414 14.3855H1.9511C1.62804 14.3855 1.36582 14.6474 1.36582 14.9708C1.36582 15.2941 1.62804 15.556 1.9511 15.556H10.3414C10.6648 15.556 10.9267 15.2941 10.9267 14.9708C10.9267 14.6474 10.6648 14.3855 10.3414 14.3855Z"
      fill="white"
    />
  </svg>
);

export const IconDiscourse = (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.11438 0.781048C0.614284 1.28115 0.333333 1.95942 0.333333 2.66667V8C0.333333 8.70724 0.614284 9.38552 1.11438 9.88562C1.61448 10.3857 2.29276 10.6667 3 10.6667H5.66667V14.6667L9.66667 10.6667H12.3333C13.0406 10.6667 13.7189 10.3857 14.2189 9.88562C14.719 9.38552 15 8.70724 15 8V2.66667C15 1.95942 14.719 1.28115 14.2189 0.781048C13.7189 0.280951 13.0406 0 12.3333 0H3C2.29276 0 1.61448 0.280951 1.11438 0.781048ZM17.6667 8V5.33333H19C19.7073 5.33333 20.3855 5.61428 20.8856 6.11438C21.3857 6.61448 21.6667 7.29276 21.6667 8V13.3333C21.6667 14.0406 21.3857 14.7189 20.8856 15.2189C20.3855 15.719 19.7073 16 19 16H16.3333V20L12.3333 16H9.66668C9.21468 16 8.78935 15.888 8.41602 15.6893L10.7707 13.3333H12.3333C13.7478 13.3333 15.1044 12.7714 16.1046 11.7712C17.1048 10.771 17.6667 9.41449 17.6667 8Z"
      fill="white"
    />
  </svg>
);

export const IconOrganizationProfile = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 6.75C5.75 5.64543 6.64543 4.75 7.75 4.75H16.25C17.3546 4.75 18.25 5.64543 18.25 6.75V19.25H5.75V6.75Z"
      stroke="#5345F6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.25 19.25H4.75"
      stroke="#5345F6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 15.75C9.75 14.6454 10.6454 13.75 11.75 13.75H12.25C13.3546 13.75 14.25 14.6454 14.25 15.75V19.25H9.75V15.75Z"
      stroke="#5345F6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z"
      fill="#5345F6"
    />
    <path
      d="M14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11Z"
      fill="#5345F6"
    />
  </svg>
);

export const IconSignOut = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 8.75L19.25 12L15.75 15.25"
      stroke="#E82A3A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 12H10.75"
      stroke="#E82A3A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.25 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H15.25"
      stroke="#E82A3A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconProfileButton = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 11.25C13.7949 11.25 15.25 9.79493 15.25 8C15.25 6.20507 13.7949 4.75 12 4.75C10.2051 4.75 8.75 6.20507 8.75 8C8.75 9.79493 10.2051 11.25 12 11.25Z"
      stroke="#159570"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.848 19.25H17.153C18.294 19.25 19.174 18.268 18.641 17.258C17.856 15.773 16.068 14 12 14C7.932 14 6.144 15.773 5.36 17.258C4.826 18.268 5.706 19.25 6.847 19.25H6.848Z"
      stroke="#159570"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconSecurity = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 17C8.15802 17 8.37937 16.9368 8.5928 16.834C13.1699 14.5415 14.743 13.2292 14.743 10.3992V4.65217C14.743 3.54545 14.3794 3.09486 13.407 2.68379C12.6402 2.36759 9.8181 1.40316 9.09873 1.17391C8.75881 1.07115 8.33984 1 7.99992 1C7.66 1 7.24893 1.07905 6.90901 1.17391C6.18174 1.39526 3.3596 2.36759 2.5928 2.68379C1.62838 3.08696 1.25684 3.54545 1.25684 4.65217V10.3992C1.25684 13.2292 2.87739 14.4625 7.41494 16.834C7.62047 16.9447 7.84182 17 7.99992 17Z"
      fill="#159570"
      fill-opacity="0.1"
      stroke="#159570"
    />
  </svg>
);

export const IconCamera = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.60005 6.99922C4.85744 6.99922 4.14525 7.29422 3.62015 7.81932C3.09505 8.34442 2.80005 9.05661 2.80005 9.79922V20.9992C2.80005 21.7418 3.09505 22.454 3.62015 22.9791C4.14525 23.5042 4.85744 23.7992 5.60005 23.7992H22.4C23.1427 23.7992 23.8548 23.5042 24.3799 22.9791C24.905 22.454 25.2 21.7418 25.2 20.9992V9.79922C25.2 9.05661 24.905 8.34442 24.3799 7.81932C23.8548 7.29422 23.1427 6.99922 22.4 6.99922H20.1796C19.8084 6.99914 19.4523 6.85159 19.1898 6.58902L17.6204 5.01962C17.0955 4.49448 16.3834 4.19938 15.6408 4.19922H12.3592C11.6167 4.19938 10.9046 4.49448 10.3796 5.01962L8.81025 6.58902C8.54776 6.85159 8.19172 6.99914 7.82045 6.99922H5.60005ZM14 19.5992C14.5516 19.5992 15.0978 19.4906 15.6073 19.2795C16.1169 19.0684 16.5799 18.7591 16.9699 18.3691C17.3599 17.9791 17.6693 17.5161 17.8803 17.0065C18.0914 16.4969 18.2 15.9508 18.2 15.3992C18.2 14.8477 18.0914 14.3015 17.8803 13.7919C17.6693 13.2824 17.3599 12.8194 16.9699 12.4294C16.5799 12.0394 16.1169 11.73 15.6073 11.5189C15.0978 11.3079 14.5516 11.1992 14 11.1992C12.8861 11.1992 11.8179 11.6417 11.0302 12.4294C10.2425 13.217 9.80005 14.2853 9.80005 15.3992C9.80005 16.5131 10.2425 17.5814 11.0302 18.3691C11.8179 19.1567 12.8861 19.5992 14 19.5992V19.5992Z"
      fill="white"
    />
  </svg>
);

export const IconAnalytics = (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 1C7 0.447715 7.44772 0 8 0H11C11.5523 0 12 0.447715 12 1V19C12 19.5523 11.5523 20 11 20H8C7.44772 20 7 19.5523 7 19V1ZM0 9C0 8.44771 0.447715 8 1 8H4C4.55228 8 5 8.44772 5 9V19C5 19.5523 4.55228 20 4 20H1C0.447715 20 0 19.5523 0 19V9ZM15 11C14.4477 11 14 11.4477 14 12V19C14 19.5523 14.4477 20 15 20H18C18.5523 20 19 19.5523 19 19V12C19 11.4477 18.5523 11 18 11H15Z"
      fill="white"
    />
  </svg>
);

export const IconPulse = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.00001 4.67889C2.00001 3.19877 2.89501 2 3.99401 2H16.006C17.107 2 18 3.20277 18 4.67889V15.3211C18 16.8012 17.105 18 16.006 18H3.99401C3.46347 17.9968 2.95555 17.7131 2.58172 17.2111C2.20789 16.7091 1.99868 16.0299 2.00001 15.3224V4.68022V4.67889ZM8.106 15.9305C8.521 17.0373 9.745 16.8586 9.97 15.6585L11.22 8.99125L12.072 11.8288C12.1335 12.0336 12.2321 12.2148 12.359 12.3563C12.4858 12.4978 12.6371 12.5951 12.7991 12.6395C12.9611 12.6839 13.1289 12.674 13.2873 12.6107C13.4458 12.5474 13.59 12.4327 13.707 12.2769L15.707 9.60997C15.8025 9.48696 15.8787 9.33982 15.9311 9.17714C15.9835 9.01445 16.0111 8.83948 16.0123 8.66242C16.0134 8.48537 15.9881 8.30978 15.9378 8.14591C15.8875 7.98203 15.8133 7.83315 15.7194 7.70795C15.6255 7.58275 15.5139 7.48374 15.391 7.41669C15.2681 7.34964 15.1364 7.3159 15.0036 7.31744C14.8708 7.31898 14.7396 7.35577 14.6176 7.42565C14.4956 7.49553 14.3852 7.59712 14.293 7.72448L13.365 8.96191L11.928 4.17218C11.568 2.97075 10.265 3.08809 10.03 4.34286L8.685 11.5141L7.895 9.40462C7.82417 9.21551 7.72064 9.05157 7.59295 8.92632C7.46525 8.80106 7.31706 8.71808 7.16059 8.68422C7.00411 8.65036 6.84384 8.66658 6.693 8.73156C6.54215 8.79653 6.40505 8.9084 6.293 9.05792L4.29301 11.7248C4.1975 11.8478 4.12131 11.995 4.0689 12.1576C4.0165 12.3203 3.98891 12.4953 3.98776 12.6724C3.9866 12.8494 4.0119 13.025 4.06218 13.1889C4.11246 13.3527 4.18672 13.5016 4.28061 13.6268C4.3745 13.752 4.48616 13.851 4.60905 13.9181C4.73195 13.9851 4.86363 14.0189 4.99641 14.0173C5.12919 14.0158 5.26041 13.979 5.38241 13.9091C5.50441 13.8392 5.61476 13.7377 5.707 13.6103L6.726 12.2515L8.106 15.9318V15.9305Z"
      fill="white"
    />
  </svg>
);

export const IconContacts = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10ZM12 7C12 7.53043 11.7893 8.03914 11.4142 8.41421C11.0391 8.78929 10.5304 9 10 9C9.46957 9 8.96086 8.78929 8.58579 8.41421C8.21071 8.03914 8 7.53043 8 7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7ZM10 11C9.0426 10.9998 8.10528 11.2745 7.29942 11.7914C6.49356 12.3083 5.85304 13.0457 5.454 13.916C6.01668 14.5706 6.71427 15.0958 7.49894 15.4555C8.28362 15.8152 9.13681 16.0009 10 16C10.8632 16.0009 11.7164 15.8152 12.5011 15.4555C13.2857 15.0958 13.9833 14.5706 14.546 13.916C14.147 13.0457 13.5064 12.3083 12.7006 11.7914C11.8947 11.2745 10.9574 10.9998 10 11Z"
      fill="white"
    />
  </svg>
);

export const IconUserTeams = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6C13 6.79565 12.6839 7.55871 12.1213 8.12132C11.5587 8.68393 10.7956 9 10 9C9.20435 9 8.44129 8.68393 7.87868 8.12132C7.31607 7.55871 7 6.79565 7 6C7 5.20435 7.31607 4.44129 7.87868 3.87868C8.44129 3.31607 9.20435 3 10 3C10.7956 3 11.5587 3.31607 12.1213 3.87868C12.6839 4.44129 13 5.20435 13 6ZM18 8C18 8.53043 17.7893 9.03914 17.4142 9.41421C17.0391 9.78929 16.5304 10 16 10C15.4696 10 14.9609 9.78929 14.5858 9.41421C14.2107 9.03914 14 8.53043 14 8C14 7.46957 14.2107 6.96086 14.5858 6.58579C14.9609 6.21071 15.4696 6 16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8ZM14 15C14 13.9391 13.5786 12.9217 12.8284 12.1716C12.0783 11.4214 11.0609 11 10 11C8.93913 11 7.92172 11.4214 7.17157 12.1716C6.42143 12.9217 6 13.9391 6 15V18H14V15ZM6 8C6 8.53043 5.78929 9.03914 5.41421 9.41421C5.03914 9.78929 4.53043 10 4 10C3.46957 10 2.96086 9.78929 2.58579 9.41421C2.21071 9.03914 2 8.53043 2 8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6C4.53043 6 5.03914 6.21071 5.41421 6.58579C5.78929 6.96086 6 7.46957 6 8ZM16 18V15C16.0014 13.9833 15.7433 12.983 15.25 12.094C15.6933 11.9805 16.1568 11.9698 16.6049 12.0627C17.053 12.1556 17.474 12.3496 17.8357 12.6299C18.1974 12.9102 18.4903 13.2695 18.6921 13.6802C18.8939 14.091 18.9992 14.5424 19 15V18H16ZM4.75 12.094C4.25675 12.983 3.9986 13.9833 4 15V18H1V15C0.999808 14.542 1.10446 14.0901 1.30595 13.6789C1.50743 13.2676 1.80039 12.9079 2.16238 12.6274C2.52437 12.3469 2.94578 12.153 3.39431 12.0605C3.84284 11.9681 4.30658 11.9795 4.75 12.094Z"
      fill="white"
    />
  </svg>
);

export const IconStudio = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.19999 10.8006C9.51958 10.8006 11.4 8.83048 11.4 6.40028C11.4 3.97007 9.51958 2 7.19999 2C4.8804 2 3 3.97007 3 6.40028C3 8.83048 4.8804 10.8006 7.19999 10.8006ZM14.2 15.2002C15.7464 15.2002 17 13.8868 17 12.2667C17 10.6466 15.7464 9.33318 14.2 9.33318C12.6536 9.33318 11.4 10.6466 11.4 12.2667C11.4 13.8868 12.6536 15.2002 14.2 15.2002ZM10.6364 15.9999C10.6364 17.1045 9.78171 18 8.72735 18C7.67299 18 6.81826 17.1045 6.81826 15.9999C6.81826 14.8952 7.67299 13.9997 8.72735 13.9997C9.78171 13.9997 10.6364 14.8952 10.6364 15.9999Z"
      fill="white"
    />
  </svg>
);

export const IconAutodialer = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6.26432C2 6.75771 2.16533 7.19824 2.44087 7.56828C2.25718 8.18502 2.16533 8.837 2.16533 9.48899C2.16533 11.4802 2.97359 13.3656 4.44317 14.7753C5.06774 15.3744 5.78416 15.8502 6.53731 16.2203C6.51894 16.0793 6.50057 15.9383 6.50057 15.7974C6.50057 15.0749 6.73938 14.4053 7.14351 13.859C5.6372 12.9604 4.62687 11.3392 4.62687 9.48899C4.62687 9.13656 4.66361 8.78414 4.73708 8.44934C5.8209 8.25551 6.64753 7.35683 6.64753 6.2467C6.64753 5.01322 5.60046 4.00881 4.31458 4.00881C3.0287 4.02643 2 5.03084 2 6.26432ZM5.69231 3.23348C6.95982 2.44053 8.42939 2 9.97245 2C11.9747 2 13.8852 2.72247 15.3364 4.04405C15.4466 4.02643 15.5568 4.02643 15.6671 4.02643C16.9529 4.02643 18 5.03084 18 6.26432C18 7.4978 16.9529 8.5022 15.6671 8.5022C14.3812 8.5022 13.3341 7.4978 13.3341 6.26432C13.3341 6.03524 13.3708 5.80617 13.4443 5.59471C12.5075 4.837 11.2951 4.36123 9.97245 4.36123C9.07233 4.36123 8.22732 4.57269 7.47417 4.96035C7.12514 4.18502 6.4822 3.56828 5.69231 3.23348ZM9.97245 13.5595C10.6705 13.5595 11.2951 13.859 11.7359 14.3348C13.8117 13.6476 15.2997 11.7621 15.318 9.54185C15.4282 9.55947 15.5385 9.55947 15.6487 9.55947C16.4386 9.55947 17.155 9.31278 17.7428 8.87225C17.7612 9.06608 17.7612 9.27753 17.7612 9.47137C17.7612 11.4626 16.9529 13.348 15.4834 14.7577C14.5281 15.674 13.3708 16.326 12.1033 16.6608C11.7359 17.4537 10.9277 18 9.97245 18C8.68657 18 7.6395 16.9956 7.6395 15.7621C7.6395 14.5286 8.68657 13.5595 9.97245 13.5595Z"
      fill="white"
    />
  </svg>
);

export const IconSettings = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.93241 0.267949C9.31361 -0.0893161 8.55122 -0.0893167 7.93241 0.267949L0.999999 4.27038C0.381197 4.62765 0 5.2879 0 6.00243V14.0073C0 14.7218 0.381196 15.3821 0.999998 15.7393L7.93241 19.7418C8.55122 20.099 9.31361 20.099 9.93241 19.7418L16.8648 15.7393C17.4836 15.3821 17.8648 14.7218 17.8648 14.0073V6.00243C17.8648 5.2879 17.4836 4.62765 16.8648 4.27038L9.93241 0.267949ZM8.93238 13.4432C10.8312 13.4432 12.3705 11.9039 12.3705 10.0051C12.3705 8.10628 10.8312 6.56699 8.93238 6.56699C7.03358 6.56699 5.4943 8.10628 5.4943 10.0051C5.4943 11.9039 7.03358 13.4432 8.93238 13.4432Z"
      fill="white"
    />
  </svg>
);

export const IconAdmin = (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 9.25H12.25M0.75 2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H13.25C13.7804 0.75 14.2891 0.960714 14.6642 1.33579C15.0393 1.71086 15.25 2.21957 15.25 2.75V11.25C15.25 11.7804 15.0393 12.2891 14.6642 12.6642C14.2891 13.0393 13.7804 13.25 13.25 13.25H2.75C2.21957 13.25 1.71086 13.0393 1.33579 12.6642C0.960714 12.2891 0.75 11.7804 0.75 11.25V2.75ZM1 5.25H15H1ZM3.75 9.25H6.25H3.75Z"
      stroke="#159570"
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconHelp = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12V12ZM12 9C11.8243 8.99983 11.6517 9.04595 11.4994 9.13373C11.3472 9.22151 11.2209 9.34784 11.133 9.5C11.0696 9.61788 10.9831 9.72182 10.8788 9.80566C10.7744 9.8895 10.6543 9.95154 10.5255 9.9881C10.3967 10.0247 10.2619 10.035 10.1291 10.0185C9.99627 10.002 9.86809 9.95897 9.75218 9.89201C9.63628 9.82505 9.53499 9.7355 9.45433 9.62867C9.37367 9.52184 9.31529 9.3999 9.28263 9.27008C9.24997 9.14027 9.24371 9.00522 9.26421 8.87294C9.28472 8.74065 9.33157 8.61384 9.402 8.5C9.73222 7.92811 10.2419 7.48116 10.852 7.22846C11.4621 6.97576 12.1386 6.93144 12.7765 7.10236C13.4143 7.27328 13.978 7.64989 14.38 8.1738C14.782 8.6977 15 9.33962 15 10C15.0002 10.6206 14.8079 11.226 14.4498 11.7329C14.0916 12.2397 13.5851 12.623 13 12.83V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 10.8946 12.7071 10.7071C12.8946 10.5196 13 10.2652 13 10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9ZM12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15C11.7348 15 11.4804 15.1054 11.2929 15.2929C11.1054 15.4804 11 15.7348 11 16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17V17Z"
      fill="white"
    />
  </svg>
);

export const IconAdminSettings = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.96588 1.23412L15.4301 4.38887C15.9503 4.68923 16.2708 5.24431 16.2708 5.84503V12.1545C16.2708 12.7552 15.9503 13.3103 15.4301 13.6107L9.96588 16.7654C9.44565 17.0658 8.8047 17.0658 8.28446 16.7654L2.82027 13.6107C2.30003 13.3103 1.97956 12.7552 1.97956 12.1545V5.84503C1.97956 5.24431 2.30003 4.68923 2.82027 4.38887L8.28446 1.23412C8.8047 0.933764 9.44565 0.933764 9.96588 1.23412ZM7.78003 0.360429C8.61241 -0.120143 9.63794 -0.120143 10.4703 0.360429L15.9345 3.51518C16.7669 3.99575 17.2796 4.88389 17.2796 5.84503V12.1545C17.2796 13.1157 16.7669 14.0038 15.9345 14.4844L10.4703 17.6391C9.63794 18.1197 8.61241 18.1197 7.78003 17.6391L2.31584 14.4844C1.48347 14.0038 0.970703 13.1157 0.970703 12.1545V5.84503C0.970703 4.88389 1.48347 3.99575 2.31584 3.51518L7.78003 0.360429ZM11.4792 8.99961C11.4792 10.2997 10.4253 11.3536 9.12518 11.3536C7.8251 11.3536 6.77119 10.2997 6.77119 8.99961C6.77119 7.69954 7.8251 6.64562 9.12518 6.64562C10.4253 6.64562 11.4792 7.69954 11.4792 8.99961ZM12.488 8.99961C12.488 10.8569 10.9824 12.3625 9.12518 12.3625C7.26793 12.3625 5.76233 10.8569 5.76233 8.99961C5.76233 7.14236 7.26793 5.63677 9.12518 5.63677C10.9824 5.63677 12.488 7.14236 12.488 8.99961Z"
      fill="#616168"
    />
  </svg>
);

export const IconProfile = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.25C13.7949 11.25 15.25 9.79493 15.25 8C15.25 6.20507 13.7949 4.75 12 4.75C10.2051 4.75 8.75 6.20507 8.75 8C8.75 9.79493 10.2051 11.25 12 11.25Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.84747 19.25H17.1525C18.2944 19.25 19.174 18.2681 18.6408 17.2584C17.8563 15.7731 16.068 14 12 14C7.93198 14 6.14364 15.7731 5.35921 17.2584C4.82594 18.2681 5.70555 19.25 6.84747 19.25Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconClock = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.05566 15.25C12.0597 15.25 15.3057 12.0041 15.3057 8C15.3057 3.99594 12.0597 0.75 8.05566 0.75C4.0516 0.75 0.805664 3.99594 0.805664 8C0.805664 12.0041 4.0516 15.25 8.05566 15.25Z"
      stroke="#616168"
      stroke-width="1.5"
    />
    <path d="M8.05566 4V8L10.0557 10" stroke="#616168" stroke-width="1.5" />
  </svg>
);

export const IconEdit = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.79081 0.385797C9.29804 -0.128599 8.49903 -0.128599 8.00625 0.385797L0.961323 7.73929C0.895081 7.80843 0.848622 7.89549 0.827165 7.99067L0.0690655 11.3537C0.029107 11.531 0.0798599 11.7172 0.203223 11.846C0.326586 11.9747 0.504994 12.0277 0.674818 11.986L3.89674 11.1947C3.98793 11.1723 4.07133 11.1238 4.13757 11.0547L11.1825 3.70116L11.1825 3.70114C11.6753 3.18677 11.6753 2.35283 11.1825 1.83846L11.1825 1.83844L9.79081 0.385797ZM8.71871 1.1294C8.81801 1.02574 8.97906 1.02574 9.07836 1.1294L9.07837 1.12942L10.4701 2.58206L10.4701 2.58208C10.5694 2.68576 10.5694 2.85384 10.4701 2.95752L10.4701 2.95754L3.52648 10.2053L1.23619 10.7678L1.77508 8.37715L8.7187 1.12941L8.71871 1.1294ZM7.38235 10.9483C7.10413 10.9483 6.87859 11.1838 6.87859 11.4742C6.87859 11.7646 7.10413 12 7.38235 12H11.5519C11.8301 12 12.0557 11.7646 12.0557 11.4742C12.0557 11.1838 11.8301 10.9483 11.5519 10.9483H7.38235Z"
      fill="black"
    />
  </svg>
);

export const IconColorChecked = (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.39045 1.05022C8.37092 1.03304 8.3481 1.01979 8.3233 1.01121C8.2985 1.00264 8.27221 0.998924 8.24593 1.00027C8.21966 1.00161 8.19391 1.008 8.17017 1.01905C8.14643 1.03011 8.12516 1.04562 8.10759 1.06469L3.97271 5.52497L1.82584 3.63609C1.80634 3.61887 1.78355 3.60558 1.75878 3.59696C1.734 3.58834 1.70772 3.58457 1.68144 3.58587C1.65517 3.58716 1.62941 3.59349 1.60565 3.60449C1.58189 3.6155 1.56059 3.63097 1.54298 3.65L1.05155 4.17942C1.03391 4.19845 1.02031 4.22068 1.01151 4.24484C1.00271 4.269 0.998895 4.29461 1.00028 4.32021C1.00166 4.34581 1.00821 4.37089 1.01955 4.39402C1.0309 4.41715 1.04682 4.43787 1.0664 4.45499L3.90071 6.949C3.92802 6.97284 3.9617 6.98867 3.99785 6.99465C4.03273 7.00283 4.06925 7.00161 4.10347 6.99112C4.1377 6.98062 4.16835 6.96125 4.19214 6.93508L8.94874 1.80399C8.98417 1.76559 9.00251 1.71505 8.99972 1.66349C8.99694 1.61192 8.97326 1.56354 8.93388 1.52898L8.39045 1.05022Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
    />
  </svg>
);

export const IconBilling = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 14.25H16.25M4.75 7.75C4.75 7.21957 4.96071 6.71086 5.33579 6.33579C5.71086 5.96071 6.21957 5.75 6.75 5.75H17.25C17.7804 5.75 18.2891 5.96071 18.6642 6.33579C19.0393 6.71086 19.25 7.21957 19.25 7.75V16.25C19.25 16.7804 19.0393 17.2891 18.6642 17.6642C18.2891 18.0393 17.7804 18.25 17.25 18.25H6.75C6.21957 18.25 5.71086 18.0393 5.33579 17.6642C4.96071 17.2891 4.75 16.7804 4.75 16.25V7.75ZM5 10.25H19H5ZM7.75 14.25H10.25H7.75Z"
      stroke="#159570"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
